import { GridButtons } from "@/controls/buttons/GridButtons";
import { CatalogAdjustmentReason } from "@/pages/configuration/models/CatalogAdjustmentReason";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { reasonUrl } from "../CatalogAdjustmentReasonPage";

type Props = {
	setSelectedRowData: (adjustmentReason: CatalogAdjustmentReason) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "AdjustmentReasonName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "-",
			headerName: "",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				url: `${reasonUrl}${
					(params.data as CatalogAdjustmentReason).AdjustmentReasonId
				}`,
				id: params.data as CatalogAdjustmentReason,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "adjustmentReasonContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			flex: 1,
			minWidth: 200,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
